var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactSupportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#4878F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 44C38.6274 44 44 38.6274 44 32C44 25.3726 38.6274 20 32 20C25.3726 20 20 25.3726 20 32C20 38.6274 25.3726 44 32 44Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9375 38C33.9375 39.0701 33.0701 39.9375 32 39.9375C30.9299 39.9375 30.0625 39.0701 30.0625 38C30.0625 36.9299 30.9299 36.0625 32 36.0625C33.0701 36.0625 33.9375 36.9299 33.9375 38Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 33C32.6922 33 33.3689 32.7947 33.9445 32.4101C34.5201 32.0256 34.9687 31.4789 35.2336 30.8394C35.4985 30.1999 35.5678 29.4961 35.4327 28.8172C35.2977 28.1383 34.9644 27.5146 34.4749 27.0251C33.9854 26.5356 33.3617 26.2023 32.6828 26.0673C32.0039 25.9322 31.3001 26.0015 30.6606 26.2664C30.0211 26.5313 29.4744 26.9799 29.0899 27.5555C28.7053 28.1311 28.5 28.8078 28.5 29.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupportIcon);
export default __webpack_public_path__ + "static/media/contact-support-icon.9dd0cc5fbd617756bfc3d4f94be58ef9.svg";
export { ForwardRef as ReactComponent };